import RoutedSavableApp from 'platform/forms/save-in-progress/RoutedSavableApp';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';
import {
  DowntimeNotification,
  externalServices,
} from 'platform/monitoring/DowntimeNotification';
import {
  healthAppsBeforeSend,
  useDefaultFormData,
} from 'platform/shared/health-apps';
import { useToggleLoadingValue } from 'platform/utilities/feature-toggles';
import PropTypes from 'prop-types';
import React from 'react';
import formConfig from '../config/form';
import content from '../locales/en/content.json';
import manifest from '../manifest.json';
import { FORM_TOGGLES } from '../utils/constants';

const BROWSER_MONITORING_PROPS = {
  service: manifest.datadog.service,
  beforeSend: healthAppsBeforeSend,
};

const App = ({ location, children }) => {
  const loading = useToggleLoadingValue();

  useDefaultFormData(FORM_TOGGLES);
  useBrowserMonitoring(BROWSER_MONITORING_PROPS);

  return loading ? (
    <va-loading-indicator
      message={content['app-loading-text']}
      class="vads-u-margin-y--4"
      set-focus
    />
  ) : (
    <RoutedSavableApp formConfig={formConfig} currentLocation={location}>
      <DowntimeNotification
        appTitle={formConfig.subTitle}
        dependencies={[externalServices.mvi, externalServices.carma]}
      >
        {children}
      </DowntimeNotification>
    </RoutedSavableApp>
  );
};

App.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default App;
